import { useContext } from 'react'
import { conceptsTravelContext } from '../../../pages/cestovko/concepts'
import { TravelSearchForm } from './TravelSearchForm'

export const ConceptsTravelSearch = () => {
  const { updateFilter, filter } = useContext(conceptsTravelContext)

  return (
    <TravelSearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='opened'
    />
  )
}
